<template>
  <main class="axum-home">
    <section class="hero-section" aria-labelledby="home-title">
      <div
        class="hero-carousel"
        aria-label="Servicios destacados de AXUM"
        @mouseenter="pauseCarousel"
        @mouseleave="startCarousel"
      >
        <div
          v-for="(slide, index) in slides"
          :key="slide.title"
          class="carousel-slide"
          :class="{ active: index === activeSlide }"
          :style="{ backgroundImage: slideBackground(slide) }"
          :aria-hidden="index === activeSlide ? 'false' : 'true'"
        ></div>

        <div class="carousel-shade"></div>

        <!-- <img src="@/assets/logoinverso.png" alt="AXUM" class="carousel-logo" /> -->

        <div class="carousel-copy">
          <!-- <span class="eyebrow mb-1">Tecnología para empresas en crecimiento</span> -->
          <!-- <p class="hero-text">{{ currentSlide.title }}</p> -->
            <router-link :to="currentSlide.cardRoute" class="btn-primary-action">
              <i class="fa-solid fa-file-lines"></i>
              {{ currentSlide.cardLabel }}
            </router-link>
            <button type="button" class="btn-secondary-action" @click="openDemoModal">
              <i class="fa-solid fa-calendar-check"></i>
              {{ currentSlide.demoLabel }}
            </button>
        </div>

        <!-- <div class="carousel-caption" aria-live="polite">
          {{ currentSlide.caption }}
        </div> -->

        <button v-if="slides.length > 1" type="button" class="carousel-control prev" aria-label="Imagen anterior" @click="prevSlide">
          <i class="fa-solid fa-chevron-left"></i>
        </button>
        <button v-if="slides.length > 1" type="button" class="carousel-control next" aria-label="Siguiente imagen" @click="nextSlide">
          <i class="fa-solid fa-chevron-right"></i>
        </button>

      </div>

      <div class="hero-tags" aria-label="Servicios destacados">
        <span>CrediCore</span>
        <!-- <span>Catálogo Cosmos</span>
        <span>Odoo ERP</span>
        <span>Software a la medida</span>
        <span>Página Web</span>
        <span>Whatsapp y Email Marketing</span> -->
      </div>
    </section>

    <section class="intro-section" aria-labelledby="intro-title">
      <div>
        <span class="section-kicker">Qué hacemos</span>
        <h2 id="intro-title">Creamos soluciones digitales para que las empresas trabajen mejor, vendan más y controlen su información.</h2>
      </div>
      <p>
        AXUM desarrolla e implementa soluciones digitales adaptadas a cada cliente:
        desde sistemas administrativos y herramientas de cobranza hasta páginas web,
        catálogos virtuales, hosting, soporte, capacitación y automatización de procesos.
      </p>
    </section>

    <section id="servicios" class="services-section" aria-labelledby="services-title">
      <div class="services-header">
        <div>
          <span class="section-kicker">Servicios</span>
          <h2 id="services-title">
            Mejoramos tu negocio,
            <span>te acompañamos a crecer.</span>
          </h2>
        </div>
        <div class="services-summary">
          <p>
            AXUM une software, automatización, gestión empresarial y presencia digital
            para que cada área de tu negocio trabaje con información clara y procesos
            mejor conectados.
          </p>
          <a href="#solicitar-demo" class="services-more">Explorar más</a>
        </div>
      </div>

      <div class="services-showcase">
        <article
          v-for="(service, index) in services"
          :key="service.title"
          class="service-card"
          :class="{ featured: index === activeServiceIndex }"
          :style="{ '--service-index': index }"
          :tabindex="index === 0 ? -1 : 0"
          @click="setActiveService(index)"
          @mouseenter="setActiveService(index)"
          @focusin="setActiveService(index)"
          @keydown.enter.prevent="setActiveService(index)"
          @keydown.space.prevent="setActiveService(index)"
        >
          <router-link
            v-if="index === 0"
            to="/credicore"
            class="service-card-route"
            aria-label="Ver ficha técnica de CrediCore"
            @click.stop
            @keydown.enter.stop
          ></router-link>

          <div class="service-card-top">
            <span class="service-category">Servicio AXUM</span>
            <span class="service-arrow" aria-hidden="true">
              <i class="fa-solid fa-arrow-up-right-from-square"></i>
            </span>
          </div>

          <div class="service-visual" aria-hidden="true">
            <div class="service-wave">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div class="service-icon">
              <i :class="service.icon"></i>
            </div>
          </div>

          <div class="service-card-copy">
            <h3>{{ service.title }}</h3>
            <p>{{ service.text }}</p>
          </div>
          <span class="service-card-accent" aria-hidden="true"></span>
        </article>
      </div>
    </section>

    <section id="credicore" class="credicore-section reveal-on-scroll" aria-labelledby="credicore-title">
      <div class="credicore-copy">
        <span class="section-kicker">Producto principal</span>
        <h2 id="credicore-title">CrediCore</h2>
        <p>
          Software diseñado para gestionar créditos, mensualidades, préstamos,
          obligaciones por cobrar, pagos, mora, reportes y control de cartera desde un
          flujo centralizado y fácil de consultar.
        </p>
        <ul class="feature-list">
          <li v-for="feature in credicoreFeatures" :key="feature">
            <i class="fa-solid fa-circle-check"></i>
            {{ feature }}
          </li>
        </ul>
        <button type="button" class="btn-primary-action compact" @click="openDemoModal">
          <i class="fa-solid fa-play"></i>
          Solicitar demo
        </button>
      </div>

      <div class="product-panel" aria-label="Ficha resumen de CrediCore">
        <div class="panel-header">
          <div>
            <span>CrediCore</span>
            <strong>Control de cartera</strong>
          </div>
          <i class="fa-solid fa-chart-simple"></i>
        </div>

        <div class="portfolio-row">
          <span>Créditos activos</span>
          <strong>128</strong>
        </div>
        <div class="portfolio-row">
          <span>Pagos registrados</span>
          <strong>742</strong>
        </div>
        <div class="portfolio-row warning">
          <span>Alertas de mora</span>
          <strong>18</strong>
        </div>
        <div class="progress-area">
          <span>Recuperación mensual</span>
          <div class="progress-track">
            <div class="progress-fill"></div>
          </div>
        </div>
      </div>
    </section>

    <section class="value-section reveal-on-scroll" aria-labelledby="value-title">
      <div class="section-heading">
        <span class="section-kicker">Enfoque</span>
        <h2 id="value-title">Diseñamos tecnología para que la operación diaria se sienta más simple.</h2>
      </div>
      <div class="value-grid">
        <div
          v-for="(item, index) in values"
          :key="item.title"
          class="value-item reveal-on-scroll"
          :style="{ '--reveal-delay': `${index * 80}ms` }"
        >
          <span class="value-index" aria-hidden="true">0{{ index + 1 }}</span>
          <strong>{{ item.title }}</strong>
          <span>{{ item.text }}</span>
        </div>
      </div>
    </section>

    <section id="solicitar-demo" class="cta-section reveal-on-scroll" aria-labelledby="cta-title">
      <div>
        <span class="section-kicker">Próximo paso</span>
        <h2 id="cta-title">Hablemos de la solución que necesita tu negocio.</h2>
        <p>
          Podemos ayudarte a ordenar información, controlar clientes, mejorar ventas,
          gestionar cobros y profesionalizar tu presencia digital.
        </p>
      </div>
      <button type="button" class="btn-primary-action" @click="openDemoModal">
        <i class="fa-solid fa-paper-plane"></i>
        Solicitar demo
      </button>
    </section>

    <DemoLeadForm ref="demoModal" mode="modal" />
  </main>
</template>

<script>
import DemoLeadForm from './DemoLeadForm.vue'

export default {
  name: 'HomeApp',
  components: {
    DemoLeadForm,
  },
  data() {
    return {
      activeSlide: 0,
      activeServiceIndex: 1,
      carouselTimer: null,
      revealObserver: null,
      isMobile: false,
      slides: [
        // {
        //   image: require('@/assets/img3.jpg'),
        //   title: 'Soluciones digitales para administrar mejor ventas, clientes, cobranza y procesos.',
        //   caption: 'Desarrollamos software a la medida para negocios que necesitan operar con más orden y control.',
        // },
        // {
        //   image: require('@/assets/img2.png'),
        //   title: 'Implementamos tecnología empresarial adaptable a diferentes mercados y formas de trabajo.',
        //   caption: 'Odoo, hosting, soporte, capacitación y automatización para equipos que quieren crecer con estructura.',
        // },
        {
          image: require('@/assets/img1v2.png'),
          mobileImage: require('@/assets/img1v2-vertical.png'),
          title: 'CrediCore centraliza créditos, pagos, mora, reportes y control de cartera.',
          caption: 'Gestión clara de préstamos, mensualidades y obligaciones por cobrar desde una sola plataforma.',
          cardLabel: 'Ver ficha de CrediCore',
          cardRoute: '/credicore',
          demoLabel: 'Solicitar demo',
        },
      ],
      services: [
        {
          icon: 'fa-solid fa-hand-holding-dollar',
          title: 'CrediCore',
          text: 'Control de créditos, pagos, obligaciones, mora y cartera con reportes accionables.',
        },
        // {
        //   icon: 'fa-solid fa-layer-group',
        //   title: 'Odoo Erp',
        //   text: 'Configuración de sistemas empresariales para ventas, inventario, administración y más.',
        // },
        // {
        //   icon: 'fa-solid fa-book-open',
        //   title: 'Catálogos virtuales',
        //   text: 'Presenta productos y servicios con una experiencia digital clara, ordenada y fácil de compartir.',
        // },
        // {
        //   icon: 'fa-solid fa-globe',
        //   title: 'Páginas web profesionales',
        //   text: 'Sitios rápidos, elegantes y pensados para convertir visitas en oportunidades comerciales.',
        // },
        // {
        //   icon: 'fa-solid fa-code',
        //   title: 'Software a la medida',
        //   text: 'Sistemas diseñados alrededor de tus procesos, clientes, reportes y operación real.',
        // },
        // {
        //   icon: 'fa-solid fa-headset',
        //   title: 'Soporte, hosting y capacitación',
        //   text: 'Acompañamiento técnico para operar, mantener y aprovechar mejor tus herramientas digitales.',
        // },
      ],
      credicoreFeatures: [
        'Gestión de créditos, préstamos y mensualidades',
        'Registro de pagos, saldos, mora y obligaciones por cobrar',
        'Reportes para seguimiento financiero y control de cartera',
        'Información centralizada para tomar mejores decisiones',
      ],
      values: [
        {
          title: 'Orden administrativo',
          text: 'Procesos más claros, menos archivos dispersos y datos listos para consultar.',
        },
        {
          title: 'Control financiero',
          text: 'Seguimiento de pagos, cobros y cartera para reducir puntos ciegos.',
        },
        {
          title: 'Presencia digital',
          text: 'Páginas, catálogos y sistemas que transmiten confianza desde el primer contacto.',
        },
        {
          title: 'Transformación gradual',
          text: 'Soluciones escalables para avanzar sin perder continuidad operativa.',
        },
      ],
    }
  },
  computed: {
    currentSlide() {
      return this.slides[this.activeSlide] || this.slides[0]
    },
  },
  mounted() {
    this.updateViewport()
    window.addEventListener('resize', this.updateViewport)
    this.startCarousel()
    this.$nextTick(this.initScrollReveals)
  },
  beforeUnmount() {
    this.pauseCarousel()
    if (this.revealObserver) this.revealObserver.disconnect()
    window.removeEventListener('resize', this.updateViewport)
  },
  methods: {
    slideBackground(slide) {
      const image = this.isMobile && slide.mobileImage ? slide.mobileImage : slide.image
      return `url(${image})`
    },
    updateViewport() {
      this.isMobile = window.matchMedia('(max-width: 767px)').matches
    },
    startCarousel() {
      this.pauseCarousel()
      if (this.slides.length <= 1) return
      this.carouselTimer = setInterval(() => {
        this.nextSlide()
      }, 5200)
    },
    pauseCarousel() {
      if (this.carouselTimer) {
        clearInterval(this.carouselTimer)
        this.carouselTimer = null
      }
    },
    nextSlide() {
      this.activeSlide = (this.activeSlide + 1) % this.slides.length
    },
    prevSlide() {
      this.activeSlide = (this.activeSlide - 1 + this.slides.length) % this.slides.length
    },
    setActiveService(index) {
      this.activeServiceIndex = index
    },
    initScrollReveals() {
      const elements = this.$el.querySelectorAll('.reveal-on-scroll')

      if (!('IntersectionObserver' in window)) {
        elements.forEach((element) => element.classList.add('is-visible'))
        return
      }

      this.revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          entry.target.classList.add('is-visible')
          observer.unobserve(entry.target)
        })
      }, {
        threshold: 0.14,
        rootMargin: '0px 0px -48px',
      })

      elements.forEach((element) => this.revealObserver.observe(element))
    },
    openDemoModal() {
      this.$refs.demoModal.open()
    },
  },
}
</script>

<style scoped>
.axum-home {
  --charcoal: #434341;
  --sand: #f4ba56;
  --silver: #dbdbdb;
  --white: #ffffff;
  --oxford: #14213d;
  --blue: #0a3d91;
  --soft-bg: #f7f7f8;
  color: var(--charcoal);
  font-family: "Montserrat", sans-serif;
  overflow: clip;
}

.axum-home,
.axum-home * {
  box-sizing: border-box;
}

.axum-home :where(h1, h2, h3, h4, h5, h6, p, a, button, span, li, strong, small, label) {
  font-family: "Montserrat", sans-serif;
}

.hero-section,
.intro-section,
.services-section,
.credicore-section,
.value-section,
.cta-section {
  max-width: 1500px;
  margin: 0 auto;
  padding-inline: clamp(24px, 5.35vw, 80px);
}

.hero-section {
  box-sizing: border-box;
  max-width: 1456px;
  /* min-height: calc(100vh - 104px); */
  padding-block: 22px 34px;
}

.hero-carousel {
  position: relative;
  width: 1400px;
  max-width: 100%;
  aspect-ratio: 1936 / 812;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 18px;
  background-color: var(--oxford);
  box-shadow: 0 24px 60px rgba(20, 33, 61, 0.16);
  isolation: isolate;
}

.carousel-slide {
  position: absolute;
  inset: 0;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  opacity: 0;
  transform: scale(1.035);
  transition: opacity 900ms ease, transform 5200ms ease;
  z-index: 0;
}

.carousel-slide.active {
  opacity: 1;
  transform: scale(1);
}

.carousel-shade {
  position: absolute;
  inset: 0;
  /* background:
    linear-gradient(90deg, 
      rgba(20, 33, 61, 0.42) 0%, 
      rgba(20, 33, 61, 0.24) 42%, 
      rgba(20, 33, 61, 0.05) 100%
    ),
    linear-gradient(0deg, 
      rgba(20, 33, 61, 0.25) 0%, 
      rgba(20, 33, 61, 0.03) 42%, 
      rgba(20, 33, 61, 0.10) 100%
    ); */
  z-index: 1;
}

.carousel-logo {
  position: absolute;
  top: 30px;
  right: 34px;
  width: 150px;
  height: auto;
  z-index: 2;
  filter: drop-shadow(0 10px 16px rgba(0, 0, 0, 0.22));
}

.carousel-copy {
  position: absolute;
  right: 0;
  bottom: clamp(16px, 2.2vw, 30px);
  left: 0;
  display: flex;
  z-index: 2;
  width: 100%;
  padding-inline: clamp(18px, 3vw, 42px);
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.carousel-copy .eyebrow {
  color: rgba(255, 255, 255, 0.94);
  font-size: 0.68rem;
}

.carousel-copy h1 {
  margin: 12px 0 14px;
  color: var(--white);
  font-size: clamp(1.55rem, 3vw, 2.75rem);
  font-weight: 900;
  line-height: 0.98;
  text-shadow: 0 12px 24px rgba(0, 0, 0, 0.16);
}

.carousel-caption {
  position: absolute;
  left: 50%;
  bottom: 30px;
  z-index: 2;
  width: min(760px, calc(100% - 180px));
  padding: 13px 28px;
  color: var(--white);
  font-size: clamp(0.82rem, 1.35vw, 1rem);
  /* font-weight: 900; */
  line-height: 1.24;
  text-align: center;
  border: 0;
  border-radius: 999px;
  background-color: rgba(10, 61, 145, 0.38);
  backdrop-filter: blur(12px);
  transform: translateX(-50%);
}

.carousel-control {
  position: absolute;
  top: 50%;
  z-index: 3;
  width: 46px;
  height: 46px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--white);
  border: 1px solid rgba(255, 255, 255, 0.32);
  border-radius: 50%;
  background-color: rgba(20, 33, 61, 0.22);
  backdrop-filter: blur(10px);
  transform: translateY(-50%);
  transition: background-color 180ms ease, transform 180ms ease;
}

.carousel-control:hover {
  background-color: rgba(20, 33, 61, 0.52);
  transform: translateY(-50%) scale(1.04);
}

.carousel-control.prev {
  left: 34px;
}

.carousel-control.next {
  right: 34px;
}

.eyebrow,
.section-kicker {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  color: var(--blue);
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.eyebrow::before,
.section-kicker::before {
  content: "";
  width: 28px;
  height: 2px;
  margin-right: 10px;
  background-color: var(--sand);
}

.hero-text {
  max-width: 680px;
  color: rgba(255, 255, 255, 0.9);
  font-size: clamp(0.9rem, 1.45vw, 1.04rem);
  line-height: 1.52;
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
}

.btn-primary-action,
.btn-secondary-action {
  min-height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 13px 20px;
  border-radius: 999px;
  font-size: 0.92rem;
  font-weight: 800;
  text-decoration: none;
  margin: 0;
  transition: transform 180ms ease, box-shadow 180ms ease, background-color 180ms ease;
  width: min(220px, 100%);
}

.btn-primary-action {
  color: var(--white);
  border: 0;
  background-color: var(--oxford);
  box-shadow: 0 18px 34px rgba(20, 33, 61, 0.16);
}

.btn-primary-action:hover,
.btn-secondary-action:hover {
  transform: translateY(-2px);
}

.btn-primary-action:hover {
  background-color: var(--blue);
}

.btn-secondary-action {
  color: var(--oxford);
  border: 1px solid var(--silver);
  background-color: var(--white);
}

.btn-secondary-action:hover {
  box-shadow: 0 14px 24px rgba(67, 67, 65, 0.1);
}

.carousel-copy .btn-primary-action {
  min-height: 42px;
  padding: 10px 17px;
  color: var(--oxford);
  font-size: 0.82rem;
  background-color: var(--sand);
  box-shadow: 0 18px 34px rgba(0, 0, 0, 0.18);
}

.carousel-copy .btn-primary-action:hover {
  background-color: #ffd17c;
}

.carousel-copy .btn-secondary-action {
  min-height: 42px;
  padding: 10px 17px;
  color: var(--white);
  font-size: 0.82rem;
  border-color: rgba(255, 255, 255, 0.42);
  background-color: rgba(0, 0, 0, 0.875);
  /* backdrop-filter: blur(10px); */
}

.carousel-copy .btn-secondary-action:hover {
  background-color: rgba(0, 0, 0, 0.866);
}

.btn-primary-action.compact {
  width: fit-content;
  margin-top: 8px;
}

.hero-tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-top: 18px;
}

.hero-tags span {
  padding: 8px 12px;
  color: var(--oxford);
  font-size: 0.82rem;
  font-weight: 700;
  border: 1px solid rgba(20, 33, 61, 0.12);
  border-radius: 999px;
  background-color: var(--white);
}

.feature-list i {
  color: var(--sand);
}

.intro-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding-block: 72px;
  border-top: 1px solid rgba(219, 219, 219, 0.75);
  text-align: center;
}

.intro-section h2,
.section-heading h2,
.credicore-copy h2,
.cta-section h2 {
  margin: 12px 0 0;
  color: var(--oxford);
  font-size: clamp(2rem, 4vw, 3.2rem);
  font-weight: 500;
  line-height: 1.06;
}

.intro-section p,
.credicore-copy p,
.cta-section p {
  color: #5b5b57;
  font-size: 1rem;
  line-height: 1.82;
}

.intro-section p {
  max-width: 850px;
  margin: 0 auto;
  text-align: center;
}

.services-section {
  position: relative;
  overflow: hidden;
  padding-block: 80px 92px;
  border-radius: 0;
  font-family: "Montserrat", sans-serif;
  background:
    linear-gradient(rgba(10, 61, 145, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(10, 61, 145, 0.05) 1px, transparent 1px),
    linear-gradient(180deg, #fbfbfc 0%, #f7f7f8 100%);
  background-size: 42px 42px, 42px 42px, auto;
}

.value-section {
  padding-block: 72px;
}

.section-heading {
  max-width: 760px;
  margin-bottom: 34px;
}

.services-header {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(280px, 0.95fr);
  gap: 72px;
  align-items: start;
  margin-bottom: 66px;
}

.services-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  padding: 7px 12px;
  color: var(--blue);
  font-size: 0.66rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-family: inherit;
  border-radius: 999px;
  background-color: rgba(244, 186, 86, 0.18);
}

.services-pill i {
  color: var(--sand);
  font-size: 0.72rem;
}

.services-header h2 {
  max-width: 590px;
  margin: 18px 0 0;
  color: var(--oxford);
  font-size: clamp(1.75rem, 3.6vw, 3.25rem);
  font-weight: 500;
  line-height: 1.06;
  font-family: inherit;
}

.services-header h2 span {
  display: block;
  color: var(--blue);
}

.services-summary {
  max-width: 460px;
  justify-self: end;
  padding-top: 22px;
}

.services-summary p {
  color: #5f6368;
  font-size: 0.9rem;
  line-height: 1.72;
  font-family: inherit;
}

.services-more {
  min-height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 22px;
  padding: 10px 22px;
  color: #ffffff;
  font-size: 0.78rem;
  font-weight: 800;
  font-family: inherit;
  text-decoration: none;
  border-radius: 999px;
  background-color: var(--oxford);
  box-shadow: 0 14px 24px rgba(20, 33, 61, 0.24);
  transition: transform 180ms ease, background-color 180ms ease;
}

.services-more:hover {
  background-color: var(--blue);
  transform: translateY(-2px);
}

.services-showcase {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  --service-ease: cubic-bezier(0.22, 1, 0.36, 1);
}

.service-card {
  position: relative;
  isolation: isolate;
  min-height: 330px;
  display: flex;
  flex-direction: column;
  padding: 26px;
  overflow: hidden;
  border: 1px solid rgba(20, 33, 61, 0.09);
  border-radius: 18px;
  background:
    radial-gradient(circle at 88% 6%, rgba(244, 186, 86, 0.11), transparent 28%),
    rgba(255, 255, 255, 0.92);
  box-shadow: 0 16px 42px rgba(20, 33, 61, 0.07);
  transition:
    transform 420ms var(--service-ease),
    box-shadow 420ms ease,
    border-color 420ms ease,
    background 420ms ease;
  cursor: pointer;
  animation: serviceCardReveal 680ms var(--service-ease) both;
  animation-delay: calc(var(--service-index) * 80ms);
}

.service-card::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -2;
  opacity: 0;
  background:
    radial-gradient(circle at 82% 10%, rgba(10, 95, 210, 0.52), transparent 34%),
    linear-gradient(145deg, #18345f 0%, var(--oxford) 68%, #0d192d 100%);
  transition: opacity 420ms ease;
}

.service-card::after {
  content: "";
  position: absolute;
  width: 180px;
  height: 180px;
  right: -98px;
  bottom: -112px;
  z-index: -1;
  border: 1px solid rgba(10, 61, 145, 0.13);
  border-radius: 50%;
  transition: border-color 420ms ease, transform 520ms var(--service-ease);
}

.service-card.featured {
  border-color: rgba(244, 186, 86, 0.42);
  box-shadow: 0 24px 54px rgba(20, 33, 61, 0.2);
  transform: translateY(-5px);
}

.service-card.featured::before {
  opacity: 1;
}

.service-card.featured::after {
  border-color: rgba(244, 186, 86, 0.24);
  transform: scale(1.2);
}

.service-card-route {
  position: absolute;
  inset: 0;
  z-index: 5;
  border-radius: inherit;
}

.service-card-route:focus-visible {
  outline: 3px solid var(--sand);
  outline-offset: -6px;
}

.service-card:hover,
.service-card:focus-visible,
.service-card:focus-within {
  outline: none;
  border-color: rgba(10, 61, 145, 0.22);
  box-shadow: 0 24px 56px rgba(20, 33, 61, 0.14);
  transform: translateY(-7px);
}

.service-card.featured:hover,
.service-card.featured:focus-visible,
.service-card.featured:focus-within {
  border-color: rgba(244, 186, 86, 0.58);
  transform: translateY(-8px);
}

.service-card-top {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.service-category {
  color: rgba(10, 61, 145, 0.46);
  font-size: 0.66rem;
  font-weight: 800;
  letter-spacing: 0.09em;
  line-height: 1;
  text-transform: uppercase;
  transition: color 420ms ease;
}

.service-arrow {
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--blue);
  font-size: 0.72rem;
  border: 1px solid rgba(10, 61, 145, 0.13);
  border-radius: 50%;
  background-color: rgba(10, 61, 145, 0.05);
  transition:
    color 360ms ease,
    background-color 360ms ease,
    border-color 360ms ease,
    transform 420ms var(--service-ease);
}

.service-card:hover .service-arrow,
.service-card:focus-visible .service-arrow,
.service-card:focus-within .service-arrow {
  transform: rotate(8deg) translateY(-2px);
}

.service-card.featured .service-category,
.service-card.featured .service-arrow {
  color: var(--sand);
}

.service-card.featured .service-arrow {
  border-color: rgba(244, 186, 86, 0.3);
  background-color: rgba(244, 186, 86, 0.1);
}

.service-visual {
  position: relative;
  height: 104px;
  display: flex;
  align-items: center;
  margin: 17px 0 20px;
}

.service-wave {
  position: absolute;
  inset: 0;
  overflow: hidden;
  opacity: 0.58;
  border-radius: 14px;
  background:
    radial-gradient(circle at 82% 20%, rgba(244, 186, 86, 0.22), transparent 35%),
    linear-gradient(135deg, rgba(10, 61, 145, 0.08), rgba(244, 186, 86, 0.05));
  transition: opacity 420ms ease, transform 520ms var(--service-ease);
}

.service-wave span {
  position: absolute;
  left: -14%;
  right: -14%;
  height: 70px;
  border-top: 1px solid rgba(10, 61, 145, 0.28);
  border-radius: 50%;
  transform: rotate(-8deg);
  transition: border-color 420ms ease, transform 620ms var(--service-ease);
}

.service-wave span:nth-child(1) {
  top: 30px;
}

.service-wave span:nth-child(2) {
  top: 44px;
  border-color: rgba(244, 186, 86, 0.34);
}

.service-wave span:nth-child(3) {
  top: 58px;
  border-color: rgba(20, 33, 61, 0.13);
}

.service-card:hover .service-wave,
.service-card:focus-visible .service-wave,
.service-card.featured .service-wave {
  opacity: 1;
  transform: scale(1.025);
}

.service-card:hover .service-wave span,
.service-card:focus-visible .service-wave span {
  transform: rotate(-5deg) translateX(8px);
}

.service-card.featured .service-wave {
  background:
    radial-gradient(circle at 82% 20%, rgba(244, 186, 86, 0.2), transparent 35%),
    linear-gradient(135deg, rgba(255, 255, 255, 0.08), rgba(244, 186, 86, 0.05));
}

.service-card.featured .service-wave span {
  border-color: rgba(255, 255, 255, 0.18);
}

.service-card.featured .service-wave span:nth-child(2) {
  border-color: rgba(244, 186, 86, 0.48);
}

.service-icon {
  position: relative;
  z-index: 2;
  width: 54px;
  height: 54px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 18px;
  color: var(--blue);
  border: 1px solid rgba(10, 61, 145, 0.12);
  border-radius: 16px;
  background-color: rgba(255, 255, 255, 0.88);
  box-shadow: 0 12px 28px rgba(20, 33, 61, 0.09);
  font-size: 1.15rem;
  transition:
    background-color 420ms ease,
    color 420ms ease,
    border-color 420ms ease,
    transform 520ms var(--service-ease);
}

.service-card.featured .service-icon {
  color: var(--oxford);
  border-color: rgba(244, 186, 86, 0.58);
  background-color: var(--sand);
  transform: rotate(-4deg) scale(1.05);
}

.service-card:hover .service-icon,
.service-card:focus-visible .service-icon {
  transform: rotate(-4deg) scale(1.06);
}

.service-card-copy {
  position: relative;
  z-index: 2;
  margin-top: auto;
}

.service-card h3 {
  max-width: 330px;
  margin: 0;
  color: var(--oxford);
  font-size: clamp(1.05rem, 1.35vw, 1.28rem);
  font-weight: 750;
  line-height: 1.18;
  font-family: inherit;
  transition: color 420ms ease, transform 420ms var(--service-ease);
}

.service-card.featured h3 {
  color: var(--white);
}

.service-card p {
  max-width: 360px;
  margin: 11px 0 0;
  color: #5f6368;
  font-size: 0.8rem;
  line-height: 1.65;
  font-family: inherit;
  transition: color 420ms ease;
}

.service-card.featured p {
  color: rgba(255, 255, 255, 0.7);
}

.service-card-accent {
  position: absolute;
  right: 26px;
  bottom: 0;
  left: 26px;
  z-index: 3;
  height: 3px;
  border-radius: 999px 999px 0 0;
  background-color: var(--sand);
  transform: scaleX(0.18);
  transform-origin: left;
  transition: transform 520ms var(--service-ease);
}

.service-card:hover .service-card-accent,
.service-card:focus-visible .service-card-accent,
.service-card.featured .service-card-accent {
  transform: scaleX(1);
}

@keyframes serviceCardReveal {
  from {
    opacity: 0;
    transform: translateY(24px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .service-card {
    animation: none;
  }

  .service-card,
  .service-card::after,
  .service-wave,
  .service-wave span,
  .service-icon,
  .service-arrow,
  .service-card-accent {
    transition: none;
  }
}

.credicore-section {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 0.85fr);
  align-items: center;
  gap: 42px;
  padding-block: 76px;
  border-radius: 0;
}

.credicore-copy p {
  max-width: 650px;
  margin: 18px 0 22px;
}

.feature-list {
  display: grid;
  gap: 14px;
  padding: 0;
  margin: 0 0 26px;
  list-style: none;
}

.feature-list li {
  display: flex;
  gap: 10px;
  color: var(--charcoal);
  font-weight: 700;
  line-height: 1.5;
}

/* CrediCore product highlight */
.credicore-section {
  position: relative;
  isolation: isolate;
  grid-template-columns: minmax(0, 0.98fr) minmax(410px, 0.9fr);
  gap: clamp(42px, 6vw, 92px);
  margin-block: 24px;
  padding-block: 84px;
  overflow: hidden;
  border-radius: 24px;
  background:
    radial-gradient(circle at 8% 10%, rgba(244, 186, 86, 0.19), transparent 26%),
    linear-gradient(135deg, #ffffff 0%, #f8f9fc 52%, #edf2fb 100%);
}

.credicore-section::before {
  content: "";
  position: absolute;
  top: -80px;
  right: 42%;
  bottom: -80px;
  width: 1px;
  z-index: -1;
  background: linear-gradient(transparent, rgba(10, 61, 145, 0.14), transparent);
  transform: rotate(25deg);
}

.credicore-copy,
.credicore-preview {
  position: relative;
  z-index: 1;
}

.credicore-title-row {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 18px;
}

.credicore-mark {
  width: 46px;
  height: 46px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  color: var(--oxford);
  border: 1px solid rgba(244, 186, 86, 0.48);
  border-radius: 14px;
  background-color: rgba(244, 186, 86, 0.22);
  box-shadow: 0 12px 24px rgba(244, 186, 86, 0.18);
}

.credicore-title-row h2 {
  margin: 0;
  font-size: clamp(2rem, 3.8vw, 3.1rem);
}

.credicore-copy h3 {
  max-width: 600px;
  margin: 20px 0 0;
  color: var(--blue);
  font-size: clamp(1.22rem, 2vw, 1.6rem);
  font-weight: 600;
  line-height: 1.22;
}

.credicore-copy p {
  max-width: 630px;
  margin: 16px 0 20px;
}

.credicore-assurance {
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 20px;
  padding: 10px 13px;
  color: var(--oxford);
  font-size: 0.84rem;
  font-weight: 800;
  line-height: 1.35;
  border: 1px solid rgba(10, 61, 145, 0.12);
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.72);
}

.credicore-assurance i {
  color: #2c9a65;
}

.feature-list {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin: 0 0 24px;
}

.feature-list li {
  min-height: 58px;
  align-items: flex-start;
  gap: 9px;
  padding: 12px;
  font-size: 0.79rem;
  line-height: 1.45;
  border: 1px solid rgba(20, 33, 61, 0.08);
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.72);
}

.feature-list li i {
  flex: 0 0 auto;
  margin-top: 2px;
}

.credicore-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 20px;
}

.credicore-actions .btn-primary-action {
  margin: 0;
}

.product-link {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 12px 0;
  color: var(--blue);
  font-size: 0.88rem;
  font-weight: 800;
  text-decoration: none;
  transition: color 180ms ease, gap 180ms ease;
}

.product-link:hover {
  gap: 13px;
  color: var(--oxford);
}

.product-panel {
  position: relative;
  z-index: 1;
  min-height: 370px;
  padding: 26px;
  overflow: hidden;
  border: 1px solid rgba(20, 33, 61, 0.12);
  border-radius: 16px;
  background:
    radial-gradient(circle at 90% 0%, rgba(10, 95, 210, 0.4), transparent 38%),
    linear-gradient(145deg, #172f58 0%, #14213d 68%, #0e1a30 100%);
  box-shadow: 0 24px 54px rgba(20, 33, 61, 0.22);
}

.product-panel::after {
  content: "";
  position: absolute;
  right: -70px;
  bottom: -90px;
  width: 240px;
  height: 240px;
  border: 1px solid rgba(244, 186, 86, 0.24);
  border-radius: 50%;
}

.panel-header {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.16);
}

.panel-header span,
.panel-header strong {
  display: block;
}

.panel-header span {
  color: var(--sand);
  font-size: 0.8rem;
  font-weight: 800;
  letter-spacing: 0.07em;
  text-transform: uppercase;
}

.panel-header strong {
  margin-top: 6px;
  color: var(--white);
  font-size: clamp(1.28rem, 2vw, 1.6rem);
  line-height: 1.12;
}

.panel-header > i {
  color: var(--sand);
  font-size: 1.7rem;
}

.panel-highlight {
  position: relative;
  z-index: 1;
  padding: 22px 0 18px;
}

.panel-highlight span {
  display: block;
  color: rgba(255, 255, 255, 0.62);
  font-size: 0.74rem;
  font-weight: 700;
}

.panel-highlight strong {
  display: block;
  max-width: 360px;
  margin-top: 7px;
  color: var(--white);
  font-size: 1.03rem;
  line-height: 1.35;
}

.panel-stat-grid {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.panel-stat-grid > div {
  padding: 13px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.07);
}

.panel-stat-grid span {
  display: block;
  color: rgba(255, 255, 255, 0.67);
  font-size: 0.67rem;
  font-weight: 700;
}

.panel-stat-grid strong {
  display: block;
  margin-top: 7px;
  color: var(--white);
  font-size: 1.28rem;
}

.panel-stat-grid .warning strong {
  color: var(--sand);
}

.panel-footer {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 18px;
  padding-top: 16px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.7rem;
  font-weight: 700;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.panel-footer span {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.panel-footer span i {
  color: #8fe4b6;
}

.panel-footer > i {
  color: var(--sand);
}

.credicore-preview {
  min-height: 460px;
  display: grid;
  place-items: center;
  padding: 32px 20px 32px 38px;
}

.preview-orbit {
  position: absolute;
  z-index: -1;
  border: 1px solid rgba(10, 61, 145, 0.12);
  border-radius: 50%;
}

.orbit-one {
  width: 410px;
  height: 410px;
  top: 28px;
  right: -34px;
}

.orbit-two {
  width: 318px;
  height: 318px;
  right: 70px;
  bottom: 6px;
  border-color: rgba(244, 186, 86, 0.34);
}

.dashboard-shell {
  width: min(100%, 470px);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.56);
  border-radius: 18px;
  background-color: var(--oxford);
  box-shadow: 0 28px 64px rgba(20, 33, 61, 0.28);
  transform: rotate(1.4deg);
}

.dashboard-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  background-color: rgba(255, 255, 255, 0.04);
}

.dashboard-brand {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  color: var(--white);
  font-size: 0.88rem;
}

.dashboard-brand-icon,
.float-card-icon,
.alert-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.dashboard-brand-icon {
  width: 24px;
  height: 24px;
  color: var(--oxford);
  font-size: 0.69rem;
  border-radius: 7px;
  background-color: var(--sand);
}

.demo-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.62rem;
  font-weight: 700;
}

.demo-badge i {
  color: var(--sand);
}

.dashboard-main {
  padding: 22px 20px 20px;
  background:
    radial-gradient(circle at 75% 15%, rgba(10, 95, 210, 0.34), transparent 34%),
    linear-gradient(160deg, rgba(23, 48, 88, 0.96), rgba(14, 28, 54, 0.99));
}

.dashboard-heading {
  display: flex;
  justify-content: space-between;
  gap: 14px;
  align-items: flex-start;
}

.dashboard-heading span,
.dashboard-metrics span,
.recovery-heading span,
.dashboard-alert span {
  display: block;
  color: rgba(255, 255, 255, 0.67);
  font-size: 0.7rem;
  font-weight: 600;
}

.dashboard-heading strong {
  display: block;
  margin-top: 5px;
  color: var(--white);
  font-size: 1.62rem;
  line-height: 1.1;
}

.dashboard-period {
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
  padding: 7px 9px;
  color: rgba(255, 255, 255, 0.8) !important;
  font-size: 0.61rem !important;
  border: 1px solid rgba(255, 255, 255, 0.13);
  border-radius: 7px;
  background-color: rgba(255, 255, 255, 0.06);
}

.dashboard-metrics {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 20px;
}

.dashboard-metrics > div {
  padding: 13px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.06);
}

.dashboard-metrics strong {
  display: block;
  margin-top: 6px;
  color: var(--white);
  font-size: 1.3rem;
}

.dashboard-metrics small {
  display: block;
  margin-top: 5px;
  color: #8fe4b6;
  font-size: 0.59rem;
  font-weight: 700;
}

.recovery-card {
  margin-top: 10px;
  padding: 15px;
  border: 1px solid rgba(244, 186, 86, 0.25);
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(244, 186, 86, 0.17), rgba(244, 186, 86, 0.04));
}

.recovery-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.recovery-heading strong {
  display: block;
  margin-top: 4px;
  color: var(--sand);
  font-size: 1.3rem;
}

.recovery-heading > i {
  color: var(--sand);
  font-size: 1rem;
}

.chart-bars {
  height: 52px;
  display: flex;
  align-items: flex-end;
  gap: 8px;
  margin: 12px 0;
}

.chart-bars span {
  width: 100%;
  border-radius: 5px 5px 2px 2px;
  background-color: rgba(255, 255, 255, 0.26);
}

.chart-bars span:nth-child(1) { height: 36%; }
.chart-bars span:nth-child(2) { height: 54%; }
.chart-bars span:nth-child(3) { height: 48%; }
.chart-bars span:nth-child(4) { height: 76%; }
.chart-bars span:nth-child(5) { height: 62%; }
.chart-bars span:nth-child(6) { height: 91%; background-color: var(--sand); }
.chart-bars span:nth-child(7) { height: 80%; background-color: rgba(255, 255, 255, 0.68); }

.progress-track {
  width: 100%;
  height: 5px;
  overflow: hidden;
  border-radius: 999px;
  background-color: rgba(255, 255, 255, 0.18);
}

.progress-fill {
  width: 76%;
  height: 100%;
  border-radius: inherit;
  background-color: var(--sand);
}

.dashboard-alert {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  padding: 12px;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.06);
}

.alert-icon {
  width: 27px;
  height: 27px;
  flex: 0 0 auto;
  color: var(--sand);
  font-size: 0.7rem;
  border-radius: 8px;
  background-color: rgba(244, 186, 86, 0.16);
}

.dashboard-alert div {
  flex: 1;
}

.dashboard-alert strong {
  display: block;
  color: var(--white);
  font-size: 0.7rem;
}

.dashboard-alert div span {
  margin-top: 3px;
  font-size: 0.58rem;
}

.dashboard-alert > i {
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.68rem;
}

.preview-float-card {
  position: absolute;
  bottom: 44px;
  left: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  color: var(--oxford);
  border: 1px solid rgba(20, 33, 61, 0.1);
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.94);
  box-shadow: 0 18px 34px rgba(20, 33, 61, 0.15);
  transform: rotate(-3deg);
}

.float-card-icon {
  width: 29px;
  height: 29px;
  color: #238f5c;
  font-size: 0.88rem;
  border-radius: 50%;
  background-color: rgba(49, 174, 107, 0.14);
}

.preview-float-card span:not(.float-card-icon) {
  display: block;
  color: #777872;
  font-size: 0.64rem;
  font-weight: 700;
}

.preview-float-card strong {
  display: block;
  margin-top: 3px;
  color: var(--oxford);
  font-size: 0.86rem;
}

/* Original CrediCore product panel */
.credicore-section {
  position: static;
  isolation: auto;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 0.85fr);
  gap: 42px;
  margin: 0 auto;
  padding-block: 76px;
  overflow: visible;
  border-radius: 0;
  background: none;
}

.credicore-section::before {
  content: none;
}

.credicore-copy p {
  max-width: 650px;
  margin: 18px 0 22px;
}

.feature-list {
  grid-template-columns: 1fr;
  gap: 14px;
  margin: 0 0 26px;
}

.feature-list li {
  min-height: auto;
  align-items: normal;
  gap: 10px;
  padding: 0;
  font-size: inherit;
  line-height: 1.5;
  border: 0;
  border-radius: 0;
  background: transparent;
}

.product-panel {
  position: static;
  z-index: auto;
  min-height: 0;
  padding: 26px;
  overflow: visible;
  border: 1px solid rgba(20, 33, 61, 0.12);
  border-radius: 8px;
  background: var(--oxford);
  box-shadow: 0 24px 54px rgba(20, 33, 61, 0.18);
}

.product-panel::after {
  content: none;
}

.panel-header {
  position: static;
  z-index: auto;
  align-items: center;
  padding-bottom: 20px;
  margin-bottom: 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.16);
}

.panel-header span {
  color: var(--sand);
  font-size: 0.86rem;
  letter-spacing: normal;
  text-transform: none;
}

.panel-header strong {
  margin-top: 0;
  color: var(--white);
  font-size: 1.38rem;
  line-height: 1.15;
}

.panel-header > i {
  color: var(--sand);
  font-size: 1.8rem;
}

.portfolio-row {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  padding: 15px 0;
  color: var(--white);
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.portfolio-row span {
  color: rgba(255, 255, 255, 0.72);
  font-weight: 700;
}

.portfolio-row strong {
  color: var(--white);
  font-size: 1.3rem;
}

.portfolio-row.warning strong {
  color: var(--sand);
}

.progress-area {
  margin-top: 24px;
}

.progress-area span {
  display: block;
  margin-bottom: 10px;
  color: rgba(255, 255, 255, 0.78);
  font-size: 0.88rem;
  font-weight: 800;
}

.progress-track {
  width: 100%;
  height: 10px;
  overflow: hidden;
  border-radius: 999px;
  background-color: rgba(255, 255, 255, 0.16);
}

.progress-fill {
  width: 76%;
  height: 100%;
  border-radius: inherit;
  background-color: var(--sand);
}

.value-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}

.value-item {
  min-height: 164px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 18px;
  padding: 22px;
  border-left: 3px solid var(--sand);
  border-radius: 8px;
  background-color: var(--white);
}

.value-item strong {
  color: var(--oxford);
  font-size: 1rem;
}

.value-item span {
  color: #666662;
  font-size: 0.92rem;
  line-height: 1.6;
}

.cta-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
  margin-bottom: 28px;
  padding-block: 52px;
  border-top: 1px solid rgba(219, 219, 219, 0.75);
}

.cta-section p {
  max-width: 720px;
  margin-top: 16px;
}

.cta-section button {
  cursor: pointer;
  white-space: nowrap;
}

@media (max-width: 992px) {
  .credicore-section {
    grid-template-columns: 1fr;
    gap: 28px;
  }

  .credicore-preview {
    width: min(100%, 560px);
    min-height: 430px;
    margin: 0 auto;
  }

  .hero-section {
    min-height: auto;
  }

  .carousel-copy {
    padding-inline: 28px;
  }

  .services-header {
    grid-template-columns: 1fr;
    gap: 24px;
    margin-bottom: 42px;
  }

  .services-summary {
    justify-self: start;
    max-width: 640px;
    padding-top: 0;
  }

  .services-showcase {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .value-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .cta-section {
    align-items: flex-start;
    flex-direction: column;
  }
}

@media (max-width: 840px) {
  .hero-section,
  .intro-section,
  .services-section,
  .credicore-section,
  .value-section,
  .cta-section {
    padding-inline: 28px;
  }

  .intro-section,
  .services-section,
  .credicore-section,
  .value-section {
    padding-block: 64px;
  }

  .service-card {
    min-height: 310px;
    padding: 24px;
  }
}

@media (max-width: 767px) {
  .hero-carousel {
    aspect-ratio: 1122 / 1402;
  }

  .carousel-copy {
    bottom: 24px;
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
    padding-inline: clamp(18px, 6vw, 36px);
  }

  .carousel-copy .btn-primary-action,
  .carousel-copy .btn-secondary-action {
    width: 100%;
    min-height: 44px;
  }

  .hero-tags {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .hero-tags span {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 0;
    line-height: 1.35;
    text-align: center;
  }
}

@media (max-width: 640px) {
  .hero-section,
  .intro-section,
  .services-section,
  .credicore-section,
  .value-section,
  .cta-section {
    padding-inline: 18px;
  }

  .hero-section {
    padding-block: 18px 38px;
  }

  .hero-carousel {
    border-radius: 14px;
  }

  .carousel-logo {
    top: 22px;
    right: 22px;
    width: 112px;
  }

  .carousel-copy {
    bottom: 22px;
    padding: 0 20px;
  }

  .carousel-copy h1 {
    font-size: clamp(1.7rem, 8vw, 2.4rem);
  }

  .hero-text {
    font-size: 0.9rem;
    line-height: 1.5;
  }

  .carousel-copy .eyebrow {
    max-width: 240px;
    font-size: 0.7rem;
    line-height: 1.35;
  }

  .carousel-caption {
    bottom: 50px;
    width: calc(100% - 42px);
    padding: 12px 16px;
    border-radius: 14px;
    font-size: 0.82rem;
  }

  .carousel-control {
    top: 42%;
    bottom: auto;
    width: 40px;
    height: 40px;
    transform: translateY(-50%);
  }

  .carousel-control:hover {
    transform: translateY(-50%) scale(1.04);
  }

  .carousel-control.prev {
    left: 22px;
  }

  .carousel-control.next {
    right: 22px;
  }

  .hero-actions,
  .hero-actions .btn-primary-action,
  .hero-actions .btn-secondary-action {
    width: 100%;
  }

  .services-header h2 {
    font-size: clamp(1.65rem, 8.5vw, 2.45rem);
  }

  .services-showcase,
  .value-grid {
    grid-template-columns: 1fr;
  }

  .service-card,
  .service-card.featured {
    width: 100%;
    min-height: 300px;
    padding: 22px;
  }

  .service-wave {
    height: auto;
  }

  .intro-section,
  .services-section,
  .credicore-section,
  .value-section {
    padding-block: 54px;
  }

  .credicore-section {
    margin: 0 auto;
    border-radius: 0;
  }

  .product-panel {
    padding: 18px;
    border-radius: 8px;
  }

  .credicore-title-row {
    gap: 11px;
  }

  .credicore-mark {
    width: 40px;
    height: 40px;
    border-radius: 12px;
  }

  .credicore-assurance {
    width: 100%;
    box-sizing: border-box;
  }

  .feature-list {
    grid-template-columns: 1fr;
  }

  .credicore-actions {
    align-items: stretch;
    flex-direction: column-reverse;
  }

  .credicore-actions .btn-primary-action {
    width: 100%;
  }

  .product-link {
    justify-content: center;
  }

  .credicore-preview {
    min-height: 386px;
    padding: 22px 0 22px 16px;
  }

  .orbit-one {
    width: 330px;
    height: 330px;
    top: 22px;
    right: -70px;
  }

  .orbit-two {
    width: 250px;
    height: 250px;
    right: 8px;
    bottom: 4px;
  }

  .dashboard-shell {
    border-radius: 14px;
    transform: rotate(0.5deg);
  }

  .dashboard-topbar,
  .dashboard-main {
    padding-right: 15px;
    padding-left: 15px;
  }

  .preview-float-card {
    bottom: 18px;
    left: -2px;
    padding: 10px 11px;
  }

  .portfolio-row {
    align-items: flex-start;
    flex-direction: column;
    gap: 4px;
  }

  .cta-section button {
    width: 100%;
    white-space: normal;
  }
}

@media (max-width: 420px) {
  .hero-section,
  .intro-section,
  .services-section,
  .credicore-section,
  .value-section,
  .cta-section {
    padding-inline: 14px;
  }

  .hero-carousel {
    border-radius: 12px;
  }

  .carousel-copy {
    bottom: 14px;
    gap: 8px;
    padding-inline: 14px;
  }

  .carousel-copy .btn-primary-action,
  .carousel-copy .btn-secondary-action {
    min-height: 42px;
    padding: 9px 12px;
    font-size: 0.75rem;
  }

  .hero-tags {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .hero-tags span {
    padding-block: 9px;
  }

  .intro-section h2,
  .section-heading h2,
  .credicore-copy h2,
  .cta-section h2 {
    font-size: clamp(1.7rem, 9vw, 2.15rem);
  }

  .services-section,
  .intro-section,
  .credicore-section,
  .value-section {
    padding-block: 46px;
  }

  .service-card,
  .service-card.featured {
    min-height: 280px;
    padding: 18px;
  }

  .service-visual {
    height: 92px;
    margin-block: 14px 16px;
  }

  .value-item {
    min-height: 0;
  }

  .panel-header {
    align-items: flex-start;
  }

  .panel-header strong {
    font-size: 1.15rem;
  }
}
</style>

<style scoped>
/* Home redesign: the hero, intro and services keep their existing visual treatment. */
.credicore-section,
.value-section,
.cta-section {
  width: min(100%, 1280px);
  padding-inline: clamp(24px, 4vw, 56px);
}

.credicore-section .section-kicker,
.value-section .section-kicker,
.cta-section .section-kicker {
  gap: 10px;
  color: #0a3d91;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.14em;
}

.credicore-section .section-kicker::before,
.value-section .section-kicker::before,
.cta-section .section-kicker::before {
  width: 22px;
  margin-right: 0;
  background: #f4ba56;
}

.credicore-section {
  grid-template-columns: minmax(0, 0.9fr) minmax(360px, 0.7fr);
  gap: clamp(54px, 8vw, 116px);
  margin-block: clamp(80px, 10vw, 144px);
  padding-block: 0;
}

.credicore-copy h2 {
  margin-top: 20px;
  font-size: clamp(3rem, 6vw, 5.7rem);
  font-weight: 420;
  line-height: 0.95;
  letter-spacing: -0.065em;
}

.credicore-copy p {
  max-width: 570px;
  margin: 28px 0 34px;
  color: #676b73;
  font-size: 0.94rem;
  line-height: 1.9;
}

.feature-list {
  gap: 0;
  margin-bottom: 34px;
  border-top: 1px solid rgba(20, 33, 61, 0.11);
}

.feature-list li {
  gap: 12px;
  padding-block: 13px;
  color: #3f4652;
  font-size: 0.82rem;
  font-weight: 600;
  border-bottom: 1px solid rgba(20, 33, 61, 0.09);
}

.feature-list li i {
  margin-top: 4px;
  color: #d99b32;
}

.credicore-section .btn-primary-action {
  width: auto;
  min-height: 50px;
  margin: 0;
  padding-inline: 24px;
  border-radius: 12px;
  background: #14213d;
  box-shadow: 0 16px 32px rgba(20, 33, 61, 0.15);
}

.product-panel {
  padding: clamp(26px, 4vw, 42px);
  border: 1px solid rgba(255, 255, 255, 0.09);
  border-radius: 24px;
  background:
    radial-gradient(circle at 100% 0%, rgba(244, 186, 86, 0.16), transparent 32%),
    #14213d;
  box-shadow: 0 38px 90px rgba(20, 33, 61, 0.22);
  transform: rotate(1.2deg);
  transition: transform 500ms cubic-bezier(0.22, 1, 0.36, 1), box-shadow 500ms ease;
}

.product-panel:hover {
  box-shadow: 0 42px 96px rgba(20, 33, 61, 0.27);
  transform: rotate(0deg) translateY(-5px);
}

.panel-header {
  padding-bottom: 28px;
  margin-bottom: 8px;
}

.panel-header span {
  color: #f4ba56;
  font-size: 0.68rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.panel-header strong {
  margin-top: 7px;
  font-size: clamp(1.35rem, 2.4vw, 1.8rem);
  font-weight: 600;
}

.portfolio-row {
  align-items: center;
  padding-block: 18px;
}

.portfolio-row span {
  font-size: 0.78rem;
  font-weight: 600;
}

.portfolio-row strong {
  font-size: 1.65rem;
  font-weight: 500;
}

.progress-area {
  margin-top: 28px;
}

.progress-track {
  height: 6px;
}

.progress-fill {
  animation: progressReveal 1.4s 500ms cubic-bezier(0.22, 1, 0.36, 1) both;
  transform-origin: left;
}

.value-section {
  padding-block: clamp(82px, 9vw, 126px);
  border-top: 1px solid rgba(20, 33, 61, 0.1);
}

.section-heading {
  display: grid;
  grid-template-columns: 0.4fr 1fr;
  align-items: start;
  gap: 40px;
  max-width: none;
  margin-bottom: clamp(48px, 7vw, 80px);
}

.section-heading h2 {
  max-width: 800px;
  margin: 0;
  font-size: clamp(2.2rem, 4.2vw, 3.8rem);
  font-weight: 450;
  line-height: 1.07;
  letter-spacing: -0.045em;
}

.value-grid {
  gap: 0;
  border-top: 1px solid rgba(20, 33, 61, 0.12);
}

.value-item {
  min-height: 260px;
  justify-content: flex-start;
  gap: 0;
  padding: 30px 26px;
  border: 0;
  border-right: 1px solid rgba(20, 33, 61, 0.1);
  border-radius: 0;
  background: transparent;
  transition: background-color 300ms ease, transform 300ms ease;
}

.value-item:last-child {
  border-right: 0;
}

.value-item:hover {
  background-color: #ffffff;
  transform: translateY(-5px);
}

.value-index {
  margin-bottom: auto;
  color: #b3b7bf;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.12em;
}

.value-item strong {
  margin-bottom: 14px;
  color: #14213d;
  font-size: 1.04rem;
  font-weight: 700;
}

.value-item > span:last-child {
  color: #6c7078;
  font-size: 0.82rem;
  line-height: 1.7;
}

.cta-section {
  position: relative;
  isolation: isolate;
  width: min(calc(100% - 32px), 1280px);
  min-height: 390px;
  margin-bottom: 32px;
  padding: clamp(52px, 7vw, 88px);
  overflow: hidden;
  border: 0;
  border-radius: 30px;
  background:
    radial-gradient(circle at 88% 14%, rgba(244, 186, 86, 0.2), transparent 24%),
    #14213d;
}

.cta-section::after {
  content: "";
  position: absolute;
  right: -90px;
  bottom: -170px;
  z-index: -1;
  width: 420px;
  height: 420px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 50%;
}

.cta-section > div {
  max-width: 760px;
}

.cta-section .section-kicker {
  color: #f4ba56;
}

.cta-section h2 {
  margin-top: 20px;
  color: #ffffff;
  font-size: clamp(2.35rem, 4.7vw, 4.2rem);
  font-weight: 450;
  line-height: 1.03;
  letter-spacing: -0.05em;
}

.cta-section p {
  max-width: 650px;
  margin-top: 22px;
  color: rgba(255, 255, 255, 0.62);
  font-size: 0.9rem;
  line-height: 1.8;
}

.cta-section .btn-primary-action {
  z-index: 1;
  width: auto;
  min-height: 54px;
  margin: 0;
  padding-inline: 26px;
  color: #14213d;
  border-radius: 12px;
  background: #f4ba56;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.16);
}

.cta-section .btn-primary-action:hover {
  background: #ffd17c;
}

.reveal-on-scroll {
  opacity: 0;
  transform: translateY(28px);
  transition:
    opacity 760ms cubic-bezier(0.22, 1, 0.36, 1) var(--reveal-delay, 0ms),
    transform 760ms cubic-bezier(0.22, 1, 0.36, 1) var(--reveal-delay, 0ms);
}

.reveal-on-scroll.is-visible {
  opacity: 1;
  transform: translateY(0);
}

@keyframes progressReveal {
  from { transform: scaleX(0); }
  to { transform: scaleX(1); }
}

@media (max-width: 900px) {
  .section-heading {
    grid-template-columns: 1fr;
  }

  .credicore-section {
    grid-template-columns: 1fr;
    gap: 58px;
  }

  .product-panel {
    width: min(100%, 620px);
    margin-inline: auto;
  }

  .value-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .value-item:nth-child(2) {
    border-right: 0;
  }

  .value-item:nth-child(-n + 2) {
    border-bottom: 1px solid rgba(20, 33, 61, 0.1);
  }
}

@media (max-width: 640px) {
  .credicore-section,
  .value-section {
    padding-inline: 20px;
  }

  .credicore-section {
    margin-block: 88px;
  }

  .credicore-copy h2 {
    font-size: clamp(3rem, 17vw, 4.5rem);
  }

  .credicore-section .btn-primary-action {
    width: 100%;
  }

  .product-panel {
    padding: 24px 20px;
    border-radius: 20px;
    transform: none;
  }

  .section-heading {
    gap: 24px;
  }

  .value-grid {
    grid-template-columns: 1fr;
  }

  .value-item,
  .value-item:nth-child(2) {
    min-height: 210px;
    padding: 26px 18px;
    border-right: 0;
    border-bottom: 1px solid rgba(20, 33, 61, 0.1);
  }

  .value-item:last-child {
    border-bottom: 0;
  }

  .cta-section {
    width: calc(100% - 16px);
    min-height: 0;
    padding: 52px 24px;
    border-radius: 24px;
  }

  .cta-section h2 {
    font-size: clamp(2.15rem, 10.8vw, 3rem);
  }

  .cta-section .btn-primary-action {
    width: 100%;
    margin-top: 12px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .reveal-on-scroll,
  .reveal-on-scroll.is-visible,
  .product-panel,
  .value-item,
  .progress-fill {
    opacity: 1;
    transform: none;
    animation: none;
    transition: none;
  }
}
</style>
